import { CustomFontSource } from "@stripe/stripe-js";

const TYPEKIT_PRIMER = "7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862";

const typekitFontFace = (fontId: string, fvd: string): string =>
  `url("https://use.typekit.net/af/${fontId}/30/l?primer=${TYPEKIT_PRIMER}&fvd=${fvd}&v=3") format("woff2"), ` +
  `url("https://use.typekit.net/af/${fontId}/30/d?primer=${TYPEKIT_PRIMER}&fvd=${fvd}&v=3") format("woff")`;

/**
 * The `sofia-pro` faces the Stripe Elements iframes render, declared inline as
 * `CustomFontSource` objects rather than a `cssSrc` stylesheet URL.
 *
 * Stripe's iframes can't see the app's local `font-primary` @font-face alias, so
 * elements reference the raw `sofia-pro` family and the `Elements` group must
 * load that family itself. Inline sources are known synchronously at
 * `stripe.elements()` creation, where `fonts` is valid. A `cssSrc` is fetched
 * asynchronously and, once resolved, applied to an already-mounted element via
 * an element-level `.update()`, which Stripe rejects with "fonts should be used
 * in elements() instead" and crashes the payment UI.
 *
 * Sources mirror the `sofia-pro` faces in `common/styles/imports.less`;
 * regenerate both together if the Typekit kit (sku8ffl) changes.
 */
export const stripeCustomFonts: CustomFontSource[] = [
  {
    family: "sofia-pro",
    weight: "400",
    style: "normal",
    display: "auto",
    src: typekitFontFace("b718ff/00000000000000007735f98d", "n4"),
  },
  {
    family: "sofia-pro",
    weight: "500",
    style: "normal",
    display: "auto",
    src: typekitFontFace("19ced7/00000000000000007735f992", "n5"),
  },
  {
    family: "sofia-pro",
    weight: "600",
    style: "normal",
    display: "auto",
    src: typekitFontFace("262452/00000000000000007735f99a", "n6"),
  },
  {
    family: "sofia-pro",
    weight: "700",
    style: "normal",
    display: "auto",
    src: typekitFontFace("5d97ff/00000000000000007735f999", "n7"),
  },
];
